export default [
  {
    path: 'research-advisor',
    name: 'research-advisor',
    component: () => import('@/views/pages/research-advisor/ResearchAdvisor.vue'),
    meta: {
      pageTitle: 'Research Advisors',
      breadcrumb: [
        {
          text: 'Research Advisors',
          active: true,
        },
      ],
      resource: 'ResearchAdvisor',
    },
  },
  {
    path: 'research-advisor/add',
    name: 'research-advisor-add',
    component: () => import('@/views/pages/research-advisor/Add.vue'),
    meta: {
      pageTitle: 'Research Advisors',
      breadcrumb: [
        {
          to: { name: 'research-advisor' },
          text: 'Research Advisors',
          active: false,
        },
        {
          text: 'Add Advisor',
          active: true,
        },
      ],
      resource: 'ResearchAdvisor',
    },
  },
  {
    path: 'research-advisor/:id',
    name: 'research-advisor-view',
    component: () => import('@/views/pages/research-advisor/View.vue'),
    meta: {
      pageTitle: 'Research Advisors',
      breadcrumb: [
        {
          to: { name: 'research-advisor' },
          text: 'Research Advisors',
          active: false,
        },
        {
          text: 'View Research Advisor',
          active: true,
        },
      ],
      resource: 'ResearchAdvisor',
    },
  },
  {
    path: 'research-advisor/update/:id',
    name: 'research-advisor-update',
    component: () => import('@/views/pages/research-advisor/Update.vue'),
    meta: {
      pageTitle: 'Research Advisors',
      breadcrumb: [
        {
          to: { name: 'research-advisor' },
          text: 'Research Advisors',
          active: false,
        },
        {
          text: 'Update',
          active: true,
        },
      ],
      resource: 'ResearchAdvisor',
    },
  },
]
